import { CircularProgress, CircularProgressProps, Stack, styled } from "@mui/material";

export const Buttons = styled(Stack)(() => ({
    position: "absolute",
    bottom: 40,
    right: 40,
    overflow: "none",
    gap: 8,
}));

export const CenteredStack = styled(Stack)(({ theme }) => ({
    alignItems: "flex-start",
    justifyContent: "center",
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    paddingTop: theme.spacing(5),
}));

const bigCircularProgressSizePixels = 100;
export const BigCircularProgress = styled((props: Omit<CircularProgressProps, "size">) => {
    return <CircularProgress {...props} size={bigCircularProgressSizePixels} />;
})(() => ({}));
